import { render, staticRenderFns } from "./SectionCloserLinkBar.vue?vue&type=template&id=315c36a0&"
import script from "./SectionCloserLinkBar.vue?vue&type=script&lang=js&"
export * from "./SectionCloserLinkBar.vue?vue&type=script&lang=js&"
import style0 from "./SectionCloserLinkBar.vue?vue&type=style&index=0&id=315c36a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports